import { Component, input, model } from '@angular/core';
import { NgClass } from '@angular/common';
import { Tab, TAB_OPTIONS } from '@app/framework/underline-tabs/underline-tabs.types';

@Component({
  selector: 'app-underline-tabs',
  imports: [NgClass],
  templateUrl: './underline-tabs.component.html',
  styleUrl: './underline-tabs.component.scss',
})
export class UnderlineTabsComponent {
  tabs = input.required<Tab[]>();
  selectedTab = model.required<TAB_OPTIONS>();

  selectTab(value: TAB_OPTIONS) {
    this.selectedTab.set(value);
  }
}
